import React from 'react';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import selectArrow from '../../../assets/icon/blue_arrow.svg';
import ChallengeMedia from '../school/ChallengeMedia';
import WorkingImg from '../../../assets/icon/Working_on.svg';
import CompletedImg from '../../../assets/icon/Completed.svg';
import { CHALLENGE_ROUTE } from '../../../constants/routes.constants';
import { useHistory } from 'react-router-dom';

const KidCommonRoomChallengeList = ({ challengeList }) => {
  const history = useHistory();

  const handleChallengeClick = (id) => {
    let encodeQuery = btoa(`{"id":${id}, "slug":"challenge"}`);
    history.push({
      pathname: CHALLENGE_ROUTE,
      search: `?encrypt=${encodeQuery}`,
    });
  };

  return (
    <div className="section-div">
      <div>
        <div
          className="completed-challenges-container has-1"
          // style={{ gridRowGap: '5rem' }}
        >
          {challengeList &&
            challengeList.map((challenge) => {
              return (
                <div
                  id="3"
                  className="challenge-card challenge-myroom col-xl-4 card-1 card p-0"
                  key={challenge.id}
                >
                  <div
                    role="button"
                    onClick={() => handleChallengeClick(challenge.id)}
                  >
                    <ChallengeMedia repo={challenge} for="list" />
                  </div>
                  <div
                    className="custom-title-and-desc challenge-myroom card-body"
                    id={challenge?.id}
                    onClick={() => handleChallengeClick(challenge.id)}
                  >
                    <div className="feed-title-bar" id="3">
                      <div
                        className="challenge-title card-title h5"
                        id="3"
                        role="button"
                      >
                        {challenge.title}
                      </div>
                      <p
                        className="challenge-desc card-text"
                        id="3"
                        role="button"
                      >
                        {challenge.description}
                      </p>
                      <div className="additional-infos" id="3">
                        <div className="left" id="3">
                          <div className="accepted">
                            <div className="avatar-icon-div">
                              <div className="avatar-icon-wrapper">
                                {challenge?.accepted_dependents?.length > 0 ? (
                                  challenge?.accepted_dependents?.map(
                                    (kid, key) => {
                                      return (
                                        <span key={key}>
                                          <div className="avatar-wrapper">
                                            <div className="smallest-type">
                                              <div className="avatar-image">
                                                <img
                                                  src={getUserProfileUrl(kid)}
                                                  className="rounded-circle overlap-item"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </span>
                                      );
                                    }
                                  )
                                ) : (
                                  <span>
                                    <div className="avatar-wrapper">
                                      <div className="smallest-type">
                                        <div className="avatar-image">
                                          <img
                                            src={WorkingImg}
                                            className="rounded-circle overlap-item"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="submission-count opa">
                              {challenge?.accepted_dependent_count} working on
                            </div>
                          </div>
                          <div className="submitted">
                            <div className="avatar-icon-div">
                              <div className="avatar-icon-wrapper">
                                {challenge?.completed_dependents?.length > 0 ? (
                                  challenge?.completed_dependents?.map(
                                    (kid, key) => {
                                      return (
                                        <span key={key}>
                                          <div className="avatar-wrapper">
                                            <div className="smallest-type">
                                              <div className="avatar-image">
                                                <img
                                                  src={getUserProfileUrl(kid)}
                                                  className="rounded-circle overlap-item"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </span>
                                      );
                                    }
                                  )
                                ) : (
                                  <span>
                                    <div className="avatar-wrapper">
                                      <div className="smallest-type">
                                        <div className="avatar-image">
                                          <img
                                            src={CompletedImg}
                                            className="rounded-circle overlap-item"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="submission-count opa">
                              {challenge?.completed_dependent_count} completed
                            </div>
                          </div>
                        </div>
                        <div
                          id="3"
                          role="button"
                          style={{ alignSelf: 'center' }}
                          onClick={() => handleChallengeClick(challenge.id)}
                        >
                          <img src={selectArrow} alt="" id="3" className="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default KidCommonRoomChallengeList;
